export enum SWIMLANE_TITLE {
  FILMS = 'Films',
  GEMIST = 'Gemist',
  WATCHLIST = 'Mijn Favorieten'
}
